import React from 'react';

import Assignee from './Assignee';
import DateRange from './DateRange';
import Select from './Select';
import Watchers from './Watchers/Watchers';
import Attendees from './Attendees/Attendees';
import StudyResearchers from './StudyResearchers/StudyResearchers';
import InterviewResearchers from './InterviewResearchers/InterviewResearchers';
import SelectableAttribute from './SelectableAttribute/SelectableAttribute';
import ManuallyFlagged from './DeliveryRisks/ManuallyFlagged';
import FlagRecordButton from './DeliveryRisks/FlagRecordButton';
import CustomRecordSelector from './CustomRecordSelector/CustomRecordSelector';
import PdlcStepStakeholders from './PdlcStep/Stakeholders';

const AttributeComponents = {
  Assignee,
  Attendees,
  Watchers,
  DateRange,
  Select,
  SelectableAttribute,
  ManuallyFlagged,
  FlagRecordButton,
  CustomRecordSelector,
  PdlcStepStakeholders,
  StudyResearchers,
  InterviewResearchers,
};

export const Attribute = props => {
  const Component = AttributeComponents[props.component];

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
};
